module.exports = require("dagre");